<!--  -->
<template>
    <div class="nfTitleWrap">
        <el-row
            type="flex"
            class="top"
            align="middle"
            justify="space-between"
        >
            <!-- 顶部左侧文字 -->
            <h1 class="h1 flex-1">
                <slot name="header" />
            </h1>
            <!-- 顶部右侧文字 -->
            <el-row
                type="flex"
                justify="end"
            >
                <slot name="headerRight" />
            </el-row>
        </el-row>
        <div class="content">
            <slot name="content" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        width: {
            type: String,
            default: "100%"
        },
    },
    data () {
        return {
        }
    },
    computed: {
        sHeight () {
            return (window.outerHeight - 400) + "px"
        }
    }
}

</script>

<style lang='scss' scoped>
.nfTitleWrap {
    background: #fff;
    width: 100%;
    height: 100%;
    color: rgba(32, 44, 85, 1);
    .h1 {
        font-size: 16px;
        font-weight: 600;
    }
    .top {
        padding: 0 20px;
        height: 50px;
        line-height: 50px;
        border-bottom: 1.5px solid #e4e7ee;
    }
}
</style>
